
import { Component, Vue, Prop } from 'vue-property-decorator';
import { UpgradePricingResponseDto, UpgradeItemDto, UpgradeItemType } from 'fourwaves-shared';
import { TranslateResult } from 'vue-i18n';

@Component({})
export default class UpgradePricing extends Vue {
  @Prop({ type: Object, required: true }) readonly pricing!: UpgradePricingResponseDto;
  @Prop(Boolean) readonly cartView!: boolean;

  readonly UpgradeItemType = UpgradeItemType;

  get hasAnyTaxes(): boolean {
    return this.pricing.gst > 0 || this.pricing.qst > 0 || this.pricing.hst > 0;
  }

  get chargeItems(): UpgradeItemDto[] {
    return this.pricing.items.filter(({ type }) => type === UpgradeItemType.Charge);
  }

  get includedItems(): UpgradeItemDto[] {
    return this.pricing.items.filter(({ type }) => type === UpgradeItemType.IncludedInPackage);
  }

  get discountItems(): UpgradeItemDto[] {
    if (this.cartView) return [];
    return this.pricing.items.filter(
      ({ type }) => type === UpgradeItemType.MultiEventDiscount || type === UpgradeItemType.MultiYearDiscount,
    );
  }

  get creditItem(): UpgradeItemDto | undefined {
    return this.pricing.items.find(({ type }) => type === UpgradeItemType.CurrentPlanCredit);
  }

  get termsPath(): string {
    return this.pricing.termLengthInYears === 1 ? 'plans.pricing.terms' : 'plans.pricing.terms_renew';
  }

  get renewOn(): TranslateResult {
    const userTimezone = this.$moment.tz.guess(true);
    const renewMoment = this.$moment(this.pricing.nextInvoiceDate).tz(userTimezone);
    return this.$t('plans.pricing.annual_invoice_date', { date: renewMoment.format('LL') });
  }

  public getItemLabel(item: UpgradeItemDto): TranslateResult {
    if (item.addOnType) {
      return this.$t(`plans.addon_name.${item.addOnType}`);
    } else {
      return this.$t(`plans.package_name.${item.packageTier}`);
    }
  }

  public getUnitCost(item: UpgradeItemDto): string {
    return `${this.formatMoney(item.unitCost, this.pricing.currency)} ${this.$tc('plans.pricing.per_event', this.pricing.maxActiveEvents)}`;
  }
}
